import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContentModuleService {
  constructor(private http: HttpClient) { }

  serviceurl:string = environment.serviceurl

  getRecentContentModules(): Observable<any> {
    return this.http.get<any>(`${this.serviceurl}api/ui/content/latest/`);
  }
}
